export const ORDERS_LIST = 'ORDERS_LIST';
export const ORDERS_DETAIL = 'ORDERS_DETAIL';
export const ORDERS_LOADER = 'ORDERS_LOADER';
export const ORDER_DUE_AMOUNT = 'ORDER_DUE_AMOUNT'
